import { render, staticRenderFns } from "./LocalShopProduct.vue?vue&type=template&id=523cb5dd&scoped=true"
import script from "./LocalShopProduct.vue?vue&type=script&lang=js"
export * from "./LocalShopProduct.vue?vue&type=script&lang=js"
import style0 from "./LocalShopProduct.vue?vue&type=style&index=0&id=523cb5dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523cb5dd",
  null
  
)

export default component.exports